import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';

export default class EventFormModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    // Check if we're in edit mode (event passed as attribute)
    this.event = this.attrs.event || null;
    this.isEditMode = !!this.event;

    // Initialize streams with existing values in edit mode, empty in create mode
    this.eventTitle = Stream(this.isEditMode ? this.event.title() || '' : '');
    this.description = Stream(this.isEditMode ? this.event.description() || '' : '');
    this.location = Stream(this.isEditMode ? this.event.location() || '' : '');
    this.eventDate = Stream(this.isEditMode ? this.formatDateForInput(this.event.eventDate()) : '');
    this.eventEndDate = Stream(this.isEditMode ? this.formatDateForInput(this.event.eventEndDate()) : '');
    this.isPrivate = Stream(this.isEditMode ? !!this.event.isPrivate() : false);
    this.eventStatus = Stream(this.isEditMode ? this.event.eventStatus() || 'scheduled' : 'scheduled');
    this.loading = false;
  }

  formatDateForInput(dateStr) {
    if (!dateStr) return '';
    if (dateStr.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/)) {
      return dateStr.slice(0, 16);
    }
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  onready() {
    if (!this.$().find(':focus').length) {
      this.$().find('input, select, textarea').first().trigger('focus');
    }
  }

  className() {
    return 'EventFormModal Modal--large';
  }

  title() {
    return this.isEditMode
      ? app.translator.trans('florcarioca-rsvp.forum.event_form.title_edit')
      : app.translator.trans('florcarioca-rsvp.forum.event_form.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form-group">
          <label>{app.translator.trans('florcarioca-rsvp.forum.event_form.title_label')} *</label>
          <input
            className="FormControl"
            type="text"
            bidi={this.eventTitle}
            placeholder={app.translator.trans('florcarioca-rsvp.forum.event_form.title_placeholder')}
          />
        </div>

        <div className="Form-group">
          <label>{app.translator.trans('florcarioca-rsvp.forum.event_form.description_label')}</label>
          <textarea
            className="FormControl"
            bidi={this.description}
            rows="3"
            placeholder={app.translator.trans('florcarioca-rsvp.forum.event_form.description_placeholder')}
          />
          <p className="EventFormModal-descriptionWarning">
            {app.translator.trans('florcarioca-rsvp.forum.event_form.description_warning')}
          </p>
        </div>

        <div className="Form-group">
          <label>{app.translator.trans('florcarioca-rsvp.forum.event_form.location_label')}</label>
          <input
            className="FormControl"
            type="text"
            bidi={this.location}
            placeholder={app.translator.trans('florcarioca-rsvp.forum.event_form.location_placeholder')}
          />
        </div>

        <div className="Form-group Form-group--inline">
          <div>
            <label>{app.translator.trans('florcarioca-rsvp.forum.event_form.date_start_label')} *</label>
            <input
              className="FormControl"
              type="datetime-local"
              bidi={this.eventDate}
            />
          </div>
          <div>
            <label>{app.translator.trans('florcarioca-rsvp.forum.event_form.date_end_label')}</label>
            <input
              className="FormControl"
              type="datetime-local"
              bidi={this.eventEndDate}
            />
          </div>
        </div>

        <div className="Form-group">
          <label className="EventFormModal-privateLabel">
            <input
              type="checkbox"
              checked={this.isPrivate()}
              onchange={(e) => this.isPrivate(e.target.checked)}
            />
            {' '}{app.translator.trans('florcarioca-rsvp.forum.event_form.is_private_label')}
          </label>
        </div>

        <div className="Form-group">
          <label>{app.translator.trans('florcarioca-rsvp.forum.event_form.status_label')}</label>
          <select
            className="FormControl EventFormModal-statusSelect"
            value={this.eventStatus()}
            onchange={(e) => this.eventStatus(e.target.value)}
          >
            <option value="scheduled">{app.translator.trans('florcarioca-rsvp.forum.event_form.status_scheduled')}</option>
            <option value="confirmed">{app.translator.trans('florcarioca-rsvp.forum.event_form.status_confirmed')}</option>
            <option value="cancelled">{app.translator.trans('florcarioca-rsvp.forum.event_form.status_cancelled')}</option>
          </select>
        </div>

        <div className="Form-group">
          <Button
            className="Button Button--primary Button--block"
            loading={this.loading}
            disabled={!this.eventTitle() || !this.eventDate()}
            onclick={() => this.submit()}
          >
            {this.isEditMode
              ? app.translator.trans('florcarioca-rsvp.forum.event_form.submit_edit')
              : app.translator.trans('florcarioca-rsvp.forum.event_form.submit')}
          </Button>
        </div>
      </div>
    );
  }

  async submit() {
    this.loading = true;
    m.redraw();

    try {
      if (this.isEditMode) {
        // PATCH request for editing
        await app.request({
          method: 'PATCH',
          url: `${app.forum.attribute('apiUrl')}/events/${this.event.id()}`,
          body: {
            data: {
              attributes: {
                title: this.eventTitle(),
                description: this.description(),
                location: this.location(),
                eventDate: this.eventDate(),
                eventEndDate: this.eventEndDate() || null,
                isPrivate: this.isPrivate(),
                eventStatus: this.eventStatus(),
              },
            },
          },
        });

        this.loading = false;
        app.modal.close();

        if (this.attrs.onupdate) {
          this.attrs.onupdate();
        }

        if (this.attrs.discussion) {
          await app.store.find('discussions', this.attrs.discussion.id());
          m.redraw();
        }
      } else {
        // POST request for creating
        const event = await app.request({
          method: 'POST',
          url: `${app.forum.attribute('apiUrl')}/events`,
          body: {
            data: {
              attributes: {
                title: this.eventTitle(),
                description: this.description(),
                location: this.location(),
                eventDate: this.eventDate(),
                eventEndDate: this.eventEndDate() || null,
                isPrivate: this.isPrivate(),
                eventStatus: this.eventStatus(),
              },
            },
          },
        });

        app.modal.close();

        // Call oncreate callback if provided
        if (this.attrs.oncreate) {
          this.attrs.oncreate();
        }

        // Redirect to the created discussion
        if (event.data && event.data.relationships && event.data.relationships.discussion) {
          const discussionId = event.data.relationships.discussion.data.id;
          m.route.set(app.route('discussion', { id: discussionId }));
        }
      }
    } catch (error) {
      this.loading = false;
      m.redraw();
      throw error;
    }
  }
}
